import React from 'react';
import { Check, BookOpen } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
const tomos = [{
  num: 1,
  title: 'El Armador: Identidad y Fundamentos',
  subtitle: 'Base sólida desde el día uno',
  desc: 'Antes de dominar la cancha, tenés que entender exactamente quién sos en ella. Los fundamentos técnicos esenciales, el posicionamiento base y la identidad del armador élite desde la que se construye todo lo demás. Porque sin cimientos sólidos, cualquier habilidad avanzada colapsa bajo presión.'
}, {
  num: 2,
  title: 'Técnica de Armado: Precisión y Variedad',
  subtitle: '80+ drills listos para usar',
  desc: 'El pase de dedos perfecto. El armado en salto. Las variantes que hacen imposible leerte. Ejercicios progresivos, corrección de errores comunes y rutinas para desarrollar consistencia técnica real con una profundidad que ningún recurso gratuito puede darte.'
}, {
  num: 3,
  title: 'Distribución y Toma de Decisiones en Juego',
  subtitle: 'Planillas de decisión incluidas',
  desc: 'Aquí es donde los armadores buenos se separan de los élite. La distribución inteligente no es instinto, es un sistema. Aprendés a leer la defensa rival antes de tocar el balón, a explotar las debilidades del bloque contrario y a tomar decisiones en fracción de segundo con criterio y confianza.'
}, {
  num: 4,
  title: 'Liderazgo, Comunicación y Manejo del Equipo',
  subtitle: 'Herramientas concretas incluidas',
  desc: 'El armador que solo distribuye no alcanza el nivel élite. El armador que lidera, comunica y eleva a sus compañeros es irremplazable. Herramientas concretas de comunicación verbal y gestual, manejo de momentos difíciles y construcción de confianza con cada atacante.'
}, {
  num: 5,
  title: 'Preparación Física Específica para el Armador',
  subtitle: 'Protocolos incluidos',
  desc: 'La movilidad de muñeca y hombro, la fuerza de core, la velocidad de desplazamiento lateral, la resistencia para mantener el nivel en el quinto set. El programa físico específico para tu posición, sin gimnasio, sin excusas, aplicable desde hoy.'
}, {
  num: 6,
  title: 'El Armador Completo: Táctica, Análisis y Evolución',
  subtitle: 'Sistema de evolución a largo plazo',
  desc: 'El tomo final integra todo lo aprendido y te lleva al siguiente nivel. Análisis táctico del rival, adaptación del juego según el marcador, planificación de tu evolución a largo plazo y el legado que un armador élite construye dentro y fuera de la cancha.'
}];
const includes = ['Sistema de desarrollo listo para aplicar desde el primer entrenamiento', 'Drills con objetivo, desarrollo y variantes por nivel', 'Indicaciones técnicas y tácticas listas para usar en cancha', 'Variaciones Nivel 1, Nivel 2 y Nivel 3 por fundamento', 'Checklist pre y durante el entrenamiento', 'Planillas de autoevaluación y seguimiento de progreso', 'Adaptaciones para distintos contextos y categorías', '100% adaptado a la realidad del armador argentino'];
export const TomosSection = () => {
  return <section className="py-12 md:py-24 bg-navy-900 relative overflow-hidden" data-id="element-434">
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-gold-500/5 blur-[120px] rounded-full pointer-events-none" data-id="element-435" />
      <div className="container mx-auto px-4 relative z-10" data-id="element-436">
        <FadeIn className="text-center mb-8 md:mb-16" data-id="element-437">
          <div className="inline-flex items-center gap-2 mb-3 px-4 py-1 rounded-full bg-navy-800 border border-gold-500/30" data-id="element-438">
            <BookOpen className="w-4 h-4 text-gold-500" data-id="element-439" />
            <span className="text-xs uppercase tracking-widest text-gold-500 font-bold" data-id="element-440">
              El Sistema Completo
            </span>
          </div>
          <h2 className="text-4xl md:text-7xl font-bebas text-white mb-3 md:mb-4" data-id="element-441">
            Los 6 <span className="text-gold-500" data-id="element-442">Tomos</span>
          </h2>
          <p className="text-base md:text-xl text-gray-300 font-medium uppercase tracking-widest" data-id="element-443">
            Para armadores de todos los niveles y enfoques
          </p>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8 mb-10 md:mb-20" data-id="element-444">
          {tomos.map((tomo, i) => <FadeIn key={i} delay={i * 0.08} className="bg-gradient-to-br from-navy-950 to-navy-900 border border-navy-700 rounded-2xl p-5 md:p-8 relative overflow-hidden group hover:border-gold-500/60 hover:shadow-[0_0_30px_rgba(212,175,55,0.15)] transition-all duration-500" data-id="element-445">
              {/* Gold accent corner */}
              <div className="absolute top-0 right-0 w-24 h-24 bg-gradient-to-bl from-gold-500/10 to-transparent rounded-bl-full pointer-events-none" data-id="element-446" />

              {/* Big number bg */}
              <div className="absolute -right-6 -top-8 text-[7rem] md:text-[9rem] font-bebas text-transparent bg-clip-text bg-gradient-to-b from-gold-500/20 to-navy-700/0 group-hover:from-gold-500/40 transition-all pointer-events-none leading-none" data-id="element-447">
                {tomo.num}
              </div>

              <div className="relative z-10" data-id="element-448">
                <div className="inline-flex items-center gap-2 mb-3" data-id="element-449">
                  <span className="flex items-center justify-center w-8 h-8 rounded-full bg-gold-500 text-navy-950 font-bebas text-lg shadow-lg shadow-gold-500/30" data-id="element-450">
                    {tomo.num}
                  </span>
                  <div className="text-gold-500 font-bebas text-base md:text-lg tracking-widest" data-id="element-451">
                    TOMO {tomo.num}
                  </div>
                </div>
                <h3 className="text-lg md:text-2xl font-bold text-white mb-3 leading-tight" data-id="element-452">
                  {tomo.title}
                </h3>
                <div className="inline-block bg-navy-800 text-gold-300 text-xs md:text-sm px-3 py-1 rounded-full mb-4 md:mb-6 border border-gold-500/20 font-medium" data-id="element-453">
                  ✦ {tomo.subtitle}
                </div>
                <p className="text-gray-400 text-sm md:text-base leading-relaxed" data-id="element-454">
                  {tomo.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.2} className="max-w-4xl mx-auto bg-gradient-to-br from-navy-800/80 to-navy-900/80 border border-gold-500/30 rounded-2xl p-5 md:p-12 relative overflow-hidden" data-id="element-455">
          <div className="absolute top-0 right-0 w-40 h-40 bg-gold-500/10 blur-3xl rounded-full pointer-events-none" data-id="element-456" />
          <h3 className="text-2xl md:text-3xl font-bebas text-white text-center mb-5 md:mb-8 relative z-10" data-id="element-457">
            Cada tomo <span className="text-gold-500" data-id="element-458">incluye:</span>
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4 relative z-10" data-id="element-459">
            {includes.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-460">
                <div className="mt-0.5 bg-gold-500/20 p-1 rounded-full shrink-0 border border-gold-500/40" data-id="element-461">
                  <Check className="w-3.5 h-3.5 text-gold-500" data-id="element-462" />
                </div>
                <span className="text-gray-300 text-sm md:text-base" data-id="element-463">
                  {item}
                </span>
              </div>)}
          </div>
        </FadeIn>
      </div>
    </section>;
};